import { AdGroupBean, AdGroupControllerApi, ItemResponseAdGroupBeanObject, ListResponseAdGroupBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class AdGroupApi extends BaseApi {
    api: AdGroupControllerApi

    constructor() {
        super()
        this.api = new AdGroupControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(size: number = 20, page: number = 1, sort, search, campaign, status): Promise<ListResponseAdGroupBean> {
        return this.call(() => this.api.adGroupList(search, campaign, status, { query: { size, page, sort } }))
    }

    all(): Promise<ListResponseAdGroupBean> {
        return this.call(() => this.api.adGroupList())
    }

    allByAdvertiser(advertiserId, sort): Promise<ListResponseAdGroupBean> {
        return this.call(() => this.api.adGroupListByAdvertiser(advertiserId, { query: { sort } }))
    }

    create(adGroup: AdGroupBean): Promise<ItemResponseAdGroupBeanObject> {
        return this.call(() => this.api.createAdGroup(adGroup))
    }

    edit(id: any, bean: AdGroupBean): Promise<ItemResponseAdGroupBeanObject> {
        return this.call(() => this.api.editAdGroup(bean, id))
    }

    view(id: any): Promise<ItemResponseAdGroupBeanObject> {
        return this.call(() => this.api.adGroup(id))
    }

    delete(id: number): Promise<void> {
        return this.call(() => this.api.deleteAdGroup(id))
    }

    statusChange(id: any, status: any): Promise<void> {
        return this.call(() => this.api.statusChangeAdGroup(id, status))
    }
}

const adGroupApi = new AdGroupApi()
export default adGroupApi


// WEBPACK FOOTER //
// ./src/component/app/adGroup/AdGroupApi.ts